export default function () {
    return (
        <svg width="32" height="33" viewBox="0 0 32 33" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_7369_82571)">
                <path
                    d="M27.8 7.5H4.2C3.53726 7.5 3 8.03726 3 8.7V24.3C3 24.9627 3.53726 25.5 4.2 25.5H27.8C28.4627 25.5 29 24.9627 29 24.3V8.7C29 8.03726 28.4627 7.5 27.8 7.5Z"
                    stroke="black"
                    strokeWidth="1.2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M22 18.5H26" stroke="black" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M22 21.5H26" stroke="black" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
                <path
                    d="M18.2 10.5H6.8C6.35817 10.5 6 10.8582 6 11.3V21.7C6 22.1418 6.35817 22.5 6.8 22.5H18.2C18.6418 22.5 19 22.1418 19 21.7V11.3C19 10.8582 18.6418 10.5 18.2 10.5Z"
                    stroke="black"
                    strokeWidth="1.2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <circle cx="24" cy="13.5" r="2" stroke="black" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
            </g>
            <defs>
                <clipPath id="clip0_7369_82571">
                    <rect width="32" height="32" fill="white" transform="translate(0 0.5)" />
                </clipPath>
            </defs>
        </svg>
    );
}
